// extracted by mini-css-extract-plugin
module.exports = {"rendering":"index_rendering_3g39k"};